import ButtonTabs from "./ButtonTabs.vue";

export * from "./buttonTabs.types";

export default ButtonTabs;
